module.exports = __webpack_public_path__ + "static/media/person05.df983690.mp4";